import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AuthenticationService } from 'src/app/core/services/authentication.service';
import { LoadingService } from 'src/app/core/services/loader.service';
import { ConfirmationPopupComponent } from '../confirmation-popup/confirmation-popup.component';
import { UsersService } from '../services/users.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
})
export class ForgotPasswordComponent implements OnInit {
  selected = 'option2';
  submitted = false;
  submitted2 = false;
  forgotForm: FormGroup;
  status = true;
  loginText = 'Send Reset Link';
  panelOpenState = false;
  clientForgotMail = '';

  constructor(
    public dialogRef: MatDialogRef<ForgotPasswordComponent>,
    private _formBuilder: FormBuilder,
    private userService: UsersService,
    private auth: AuthenticationService,
    private loadingService: LoadingService,
    public dialog: MatDialog,
  ) {}

  ngOnInit(): void {
    this.forgotForm = this._formBuilder.group({
      username: ['', [Validators.required]],
    });
  }

  togglePanel() {
    this.panelOpenState = !this.panelOpenState;
  }

  openDialog(email, header: string, content: string) {
    this.dialogRef.close();
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      width: '500px',
      data: { email, header, content },
    });
  }

  /***
   * Forgot Password Implementation
   */
  forgotPassword() {
    this.submitted2 = true;
    if (this.forgotForm.invalid) {
      return;
    }
    this.loginText = 'Please Wait ...';
    this.loadingService.startLoading();
    // console.log(this.forgotForm.value);
    this.userService.forgotPass(this.forgotForm.value).subscribe(
      (response) => {
        // console.log(response);
        this.loadingService.stopLoading();
        if (response) {
          this.loginText = 'Send Reset Link';

          const msg =
            'A confirmation e-mail has been sent to ' +
            this.forgotForm.controls.username.value +
            '. Check your inbox and click on the "Confirm my email" link to confirm your email address.';
          const header = 'Confirm your email address!';

          this.openDialog(this.forgotForm.controls.username.value, header, msg);
          // alert("To reset your password please check your mail box");
        }
      },
      (error) => {
        this.loadingService.stopLoading();
        this.loginText = 'Login';
        this.submitted = false;
        // alert("Email is either incorrect or not registered.");
        this.auth.showSnackBarMsg('Email is either incorrect or not registered.')
      }
    );
  }
  backToLogin() {
    this.dialogRef.close('backToLogin');
  }
}
